import {CanActivateFn, Router} from '@angular/router';
import {inject} from "@angular/core";
import {AuthService} from "../services/auth/auth.service";

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService)
  const router = inject(Router)
  if (!authService.isAuthenticated()) {
    router.navigate(['/login'])
  }
  return authService.isAuthenticated();
};
